import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import Slider from '@mui/material/Slider';
import { APP_ROUTES, FULLPAGE_ROUTES } from '../Router/routes';

export const MainDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'customerId',
})(({ theme, open, mediaquery, drawerWidth, location, customerId }) => ({
  flex: '1 1 auto',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: mediaquery ? `-${drawerWidth}px` : 0,
  ...(open &&
    mediaquery && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  height: '80%',
  padding:
    Object.keys(APP_ROUTES).find(
      (key) => APP_ROUTES[key] === location && FULLPAGE_ROUTES.includes(key)
    ) ||
    location === '/401' ||
    customerId
      ? 'unset'
      : '16px',
}));

export const StyledList = styled(List)(({ theme }) => ({
  // selected and (selected + hover) states
  '&& .Mui-selected, && .Mui-selected:hover': {
    borderRadius: '8px',
    '&': {
      color: '#fff',
      backgroundImage:
        'linear-gradient(90.37deg, #1D5A9D 21.99%, #61B340 100%)',
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.white.main,
      background: 'transparent',
    },
  },
}));

export const StyledSlider = styled(Slider)(({ providedColor }) => ({
  color: providedColor,
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    backgroundColor: providedColor,
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 42,
    height: 42,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: providedColor,
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
}));
